module.exports = __webpack_public_path__ + "static/media/Coltisho.01408b27.ttf";